/**
 * Constants mirrored from the Rust simulation.
 *
 * These must stay in step with `crates/sim/src/units.rs` and `map.rs`. The
 * values that actually affect gameplay live in Rust and are read back through
 * wasm accessors; the ids here are only used for rendering and UI layout, so a
 * mismatch shows up as a wrong sprite rather than a desync.
 */

export const KIND_INFANTRY = 0;
export const KIND_TANK = 1;
export const KIND_HARVESTER = 2;
export const KIND_HQ = 3;
export const KIND_REFINERY = 4;
export const KIND_BARRACKS = 5;
export const KIND_WAR_FACTORY = 6;
export const KIND_COUNT = 7;

export const TILE_GRASS = 0;
export const TILE_DIRT = 1;
export const TILE_SAND = 2;
export const TILE_WATER = 3;
export const TILE_ROCK = 4;
export const TILE_ORE = 5;
export const TILE_COUNT = 6;

export const QUEUE_STRUCTURE = 0;
export const QUEUE_INFANTRY = 1;
export const QUEUE_VEHICLE = 2;

/** Command opcodes, mirroring `crates/sim/src/command.rs`. */
export const CMD_MOVE = 1;
export const CMD_ATTACK = 2;
export const CMD_ATTACK_MOVE = 3;
export const CMD_STOP = 4;
export const CMD_PRODUCE = 5;
export const CMD_PLACE = 6;
export const CMD_CANCEL = 7;
export const CMD_HARVEST = 8;

/** Event kinds emitted by the simulation for cosmetic effects. */
export const EVENT_SHOT = 0;
export const EVENT_IMPACT = 1;
export const EVENT_DEATH = 2;
export const EVENT_BUILD_COMPLETE = 3;

/** Simulation rate. The renderer interpolates between ticks. */
export const TICKS_PER_SECOND = 20;
export const TICK_MS = 1000 / TICKS_PER_SECOND;

/** Fixed-point scale used by the simulation, for encoding command positions. */
export const FIXED_ONE = 65536;

/** Field layout of the entity render buffer, mirroring `view.rs`. */
export const F_X = 0;
export const F_Y = 1;
export const F_FACING = 2;
export const F_TURRET = 3;
export const F_HP_FRAC = 4;
export const F_KIND = 5;
export const F_OWNER = 6;
export const F_ID = 7;
export const F_BUILD_FRAC = 8;
export const F_SELECTED = 9;

export const NO_ENTITY = 0xffffffff;

/** Which production tab a kind belongs to. */
export function queueOf(kind: number): number {
  switch (kind) {
    case KIND_INFANTRY:
      return QUEUE_INFANTRY;
    case KIND_TANK:
    case KIND_HARVESTER:
      return QUEUE_VEHICLE;
    default:
      return QUEUE_STRUCTURE;
  }
}

export function isBuilding(kind: number): boolean {
  return kind >= KIND_HQ;
}
